export default "__VITE_ASSET__Bvgx1DsF__"